import { useRef } from "react";
import { newIdempotencyKey } from "../api/client";

/** One `Idempotency-Key` per distinct write body: the same key while the
 *  body is unchanged (so a retry replays the original response), a fresh one
 *  as soon as it differs (so the API never sees `idempotency_conflict`). */
export function useIdempotencyKey(body: string): string {
  const ref = useRef<{ body: string; key: string } | null>(null);
  if (ref.current === null || ref.current.body !== body) {
    ref.current = { body, key: newIdempotencyKey() };
  }
  return ref.current.key;
}
